export default __webpack_public_path__ + "static/media/LAS0920.34I-41366_-24891_0.e45cfe5b.jpg";